import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachProductAutomationLayout } from "src/pages/CoachProductAutomationLayout";
import { automationQueryOptions } from "src/queries/automations";

export const Route = createFileRoute(
  "/_auth/_coach/products/$productId/automations/$automationId",
)({
  component: CoachProductAutomationLayout,
  ssr: true,
  shouldReload: false,
  async loader({ context, params }) {
    return await loaderHandler(async () => {
      const automation = await context.queryClient.query({
        ...automationQueryOptions(params.automationId),
        staleTime: "static",
      });

      return {
        data: null,
        breadcrumb: {
          id: automation.id,
          label: automation.name,
          href: `/products/${params.productId}/automations/${automation.id}`,
        },
      };
    });
  },
});
